
import { defineComponent, PropType } from 'vue'
import { DEFAULT_SIDEBAR_ITEM_SPACING, SPACING_CLASS_MAP, SpacingValue } from './spacing'

export default defineComponent({
  name: 'SidebarItemGroup',
  props: {
    /**
     * The HTML element or component to render as
     * Default: 'div'
     */
    as: {
      type: [String, Object] as PropType<string | Record<string, any>>,
      default: 'div'
    },
    /**
     * Spacing between items using Tailwind's spacing scale
     * Default: '2.5' (10px)
     * Use '1' for 4px spacing (e.g., primary sidebar)
     */
    spacing: {
      type: String as PropType<SpacingValue>,
      default: DEFAULT_SIDEBAR_ITEM_SPACING,
      validator: (value: string) => Object.keys(SPACING_CLASS_MAP).includes(value)
    }
  },
  computed: {
    spacingClass(): string {
      return (
        SPACING_CLASS_MAP[this.spacing as SpacingValue] ||
        SPACING_CLASS_MAP[DEFAULT_SIDEBAR_ITEM_SPACING]
      )
    }
  }
})
